const debounce = (func, wait) => {
    let timeout;
  
    return function executedFunction(...args) {
      const later = () => {
        timeout = null;
        func(...args);
      };
  
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  };
  

function chunkArray(myArray, chunk_size) {
    var tempArray = [];
    for (var i = 0; i < chunk_size; i++) {
        tempArray.push({
            arr: [],
            id: i
        });
    }

    var tmpI = 0;
    for (var j = 0; j < myArray.length; j++) {
        if(tmpI > tempArray.length - 1) {
            tmpI = 0;
        }
        
        tempArray[tmpI].arr.push(myArray[j])
        tmpI++;
    }

    return tempArray;
}

export default {
    debounce,
    chunkArray
}